import { render, staticRenderFns } from "./ThePart4Main.vue?vue&type=template&id=a915243c&scoped=true"
import script from "./ThePart4Main.vue?vue&type=script&lang=js"
export * from "./ThePart4Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart4Main.vue?vue&type=style&index=0&id=a915243c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a915243c",
  null
  
)

export default component.exports